import { NgModule } from '@angular/core';

import { CamelToKebabCasePipe } from './camel-to-kebab.pipe';
import { LongNameFormatterPipe } from './long-name-formatter.pipe';
import { NumberFormatterPipe } from './number-formatter.pipe';
import { PluckPipe } from './pluck.pipe';
import { PolarityPipe } from './polarity.pipe';
import { SafePipe } from './safe.pipe';
import { SlugifyPipe } from './slugify.pipe';
import { SortByAlphaPipe } from './sort-by-alpha.pipe';
import { SortByDatePipe } from './sort-by-date.pipe';
import { SplitPipe } from './split.pipe';
import { StripHtmlPipe } from './strip-html.pipe';
import { TrimPipe } from './trim.pipe';

@NgModule({
	declarations: [
		PluckPipe,
		CamelToKebabCasePipe,
		NumberFormatterPipe,
		PolarityPipe,
		LongNameFormatterPipe,
		SafePipe,
		SlugifyPipe,
		SortByAlphaPipe,
		SortByDatePipe,
		SplitPipe,
		StripHtmlPipe,
		TrimPipe
	],
	exports: [
		PluckPipe,
		CamelToKebabCasePipe,
		PolarityPipe,
		NumberFormatterPipe,
		LongNameFormatterPipe,
		SafePipe,
		SlugifyPipe,
		SortByAlphaPipe,
		SortByDatePipe,
		SplitPipe,
		StripHtmlPipe,
		TrimPipe
	]
})
export class GenericPipesModule { }
